import { render, staticRenderFns } from "./MenuChip.vue?vue&type=template&id=2d2e5336&"
import script from "./MenuChip.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MenuChip.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d2e5336')) {
      api.createRecord('2d2e5336', component.options)
    } else {
      api.reload('2d2e5336', component.options)
    }
    module.hot.accept("./MenuChip.vue?vue&type=template&id=2d2e5336&", function () {
      api.rerender('2d2e5336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/lpu/components/ChipsFilters/MenuChip.vue"
export default component.exports